/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加项目开票提醒
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,
  saleBeginTime: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/project/${productId}/${saleBeginTime}/remind`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
